var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationCrosshairsHollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 9.25C12.375 11.1133 10.8633 12.625 9 12.625C7.10156 12.625 5.625 11.1133 5.625 9.25C5.625 7.38672 7.10156 5.875 9 5.875C10.8633 5.875 12.375 7.38672 12.375 9.25ZM9 7C7.73438 7 6.75 8.01953 6.75 9.25C6.75 10.5156 7.73438 11.5 9 11.5C10.2305 11.5 11.25 10.5156 11.25 9.25C11.25 8.01953 10.2305 7 9 7ZM9 0.25C9.28125 0.25 9.5625 0.53125 9.5625 0.8125V2.53516C12.832 2.81641 15.4336 5.41797 15.7148 8.6875H17.4375C17.7188 8.6875 18 8.96875 18 9.25C18 9.56641 17.7188 9.8125 17.4375 9.8125H15.7148C15.4336 13.1172 12.832 15.7188 9.5625 16V17.6875C9.5625 18.0039 9.28125 18.25 9 18.25C8.68359 18.25 8.4375 18.0039 8.4375 17.6875V16C5.13281 15.7188 2.53125 13.1172 2.25 9.8125H0.5625C0.246094 9.8125 0 9.56641 0 9.25C0 8.96875 0.246094 8.6875 0.5625 8.6875H2.25C2.53125 5.41797 5.13281 2.81641 8.4375 2.53516V0.8125C8.4375 0.53125 8.68359 0.25 9 0.25ZM3.375 9.25C3.375 12.3789 5.87109 14.875 9 14.875C12.0938 14.875 14.625 12.3789 14.625 9.25C14.625 6.15625 12.0938 3.625 9 3.625C5.87109 3.625 3.375 6.15625 3.375 9.25Z",
    fill: "inherit",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationCrosshairsHollow);
export default __webpack_public_path__ + "static/media/location-crosshairs-hollow.f45eb7f3293c4f7d3f35e7e2346eeffc.svg";
export { ForwardRef as ReactComponent };